import React from 'react';
import LogoImage from '../assets/celestar_logo.svg';
import { Link } from 'react-router-dom';

import EmojiJoystick from '../assets/emoji_joystick.webp';
import EmojiSparkles from '../assets/emoji_sparkles.webp';
import EmojiMoney from '../assets/emoji_money.webp';
import EmojiFlag from '../assets/emoji_flag.webp';

import MobileEmojiJoystick from '../assets/mobile/emoji_joystick.webp';
import MobileEmojiSparkles from '../assets/mobile/emoji_sparkles.webp';
import MobileEmojiMoney from '../assets/mobile/emoji_money.webp';
import MobileEmojiFlag from '../assets/mobile/emoji_flag.webp';

import IconHamburger from '../assets/icon_menu.svg';
import IconClose from '../assets/icon_close.svg';
import { getUserToken } from '../utils/auth';

const SCROLL_THRESHOLD = 30;

class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: false,
      open: false,
      hasToken: !!getUserToken(),
    };
  }

  onScroll = () => {
    const { scrollY } = window;
    const { scrolled } = this.state;
    if (scrollY > SCROLL_THRESHOLD && !scrolled) {
      this.setState({
        scrolled: true,
      });
    }
    if (scrollY <= SCROLL_THRESHOLD && scrolled) {
      this.setState({
        scrolled: false,
      });
    }
  };

  setOpen = (open) => {
    this.setState({
      open,
    });
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, { passive: true });
  }

  render() {
    const { scrolled, open, hasToken } = this.state;
    const { showNav } = this.props;
    return (
      <header id="landing-header" className={scrolled ? 'scrolled' : ''}>
        <div className="fullwidth-header flex space-between align-center">
          <Link to="/">
            <img src={LogoImage} width={130} height={30} id="header-logo" alt="Celestar" />
          </Link>
          {showNav && (
            <>
              <ul id="header-nav" className={open ? 'open' : ''}>
                <button id="header-close" onClick={() => this.setOpen(false)}>
                  <img
                    alt="Close"
                    width={30}
                    height={28}
                    src={IconClose}
                    id="hamburger-close-image"
                  />
                </button>
                <li className="header-nav-item">
                  <a
                    className="header-nav-item-link"
                    href="/#process"
                    onClick={() => this.setOpen(false)}>
                    <img
                      src={EmojiJoystick}
                      srcSet={`${EmojiJoystick} 72w, ${MobileEmojiJoystick} 36w`}
                      width={72}
                      height={72}
                      alt=""
                      className="header-nav-item-icon"
                    />
                    Our process
                  </a>
                </li>
                <li className="header-nav-item">
                  <a
                    className="header-nav-item-link"
                    href="/#features"
                    onClick={() => this.setOpen(false)}>
                    <img
                      src={EmojiSparkles}
                      srcSet={`${EmojiSparkles} 72w, ${MobileEmojiSparkles} 36w`}
                      width={72}
                      height={72}
                      alt=""
                      className="header-nav-item-icon"
                    />
                    Features
                  </a>
                </li>
                <li className="header-nav-item">
                  <a
                    className="header-nav-item-link"
                    href="/#pricing"
                    onClick={() => this.setOpen(false)}>
                    <img
                      src={EmojiMoney}
                      srcSet={`${EmojiMoney} 72w, ${MobileEmojiMoney} 36w`}
                      width={72}
                      height={72}
                      alt=""
                      className="header-nav-item-icon"
                    />
                    Pricing
                  </a>
                </li>
                {hasToken ? (
                  <li className="header-nav-item">
                    <a
                      className="header-nav-item-link"
                      href="/home"
                      onClick={() => this.setOpen(false)}>
                      <img
                        src={EmojiFlag}
                        srcSet={`${EmojiFlag} 72w, ${MobileEmojiFlag} 36w`}
                        width={72}
                        height={72}
                        alt=""
                        className="header-nav-item-icon"
                      />
                      Go to Dashboard
                    </a>
                  </li>
                ) : (
                  <li className="header-nav-item">
                    <a
                      className="header-nav-item-link"
                      href="/register"
                      onClick={() => this.setOpen(false)}>
                      <img
                        src={EmojiFlag}
                        srcSet={`${EmojiFlag} 72w, ${MobileEmojiFlag} 36w`}
                        width={72}
                        height={72}
                        alt=""
                        className="header-nav-item-icon"
                      />
                      Login/Register
                    </a>
                  </li>
                )}
              </ul>
              <button id="header-hamburger" onClick={() => this.setOpen(!open)}>
                <img alt="Menu" src={IconHamburger} id="hamburger-image" width={30} height={28} />
              </button>
            </>
          )}
        </div>
      </header>
    );
  }
}

export default Header;
